







































import { Component, Vue, Emit } from "vue-property-decorator";
import { ParticipantInfo } from "../interfaces/user";

@Component
export default class ParticipantInfoCard extends Vue {
    @Emit() cancel() {
        return;
    }

    public get participantInfo(): ParticipantInfo[] {
        return this.$store.state.participantInfo;
    }
}
